export default __webpack_public_path__ + "static/avatar-special-engin-0-cover-20b53b388861d361ffced39c18b1371c.png";